/** Explore page — verified CDN URLs (Pexels + Unsplash). Cars use vehicle photos only. */

const p = (id) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=800&fit=crop`;

const u = (id) =>
  `https://images.unsplash.com/photo-${id}?w=800&q=80&fit=crop`;

export const TRAVEL_SERVICES = [
  {
    id: 'hotels',
    title: 'Hotels',
    description: 'Compare stays worldwide with flexible check-in and guest options.',
    priceHint: 'from $129/night',
    image: p(271624),
  },
  {
    id: 'cars',
    title: 'Cars',
    description: 'Premium rentals with airport, hotel, or custom pickup and drop-off.',
    priceHint: 'from $79/day',
    image: u('1555215695-3004980ad54e'),
  },
  {
    id: 'packages',
    title: 'Packages',
    description: 'Flight + hotel bundles and vacation packages in top destinations.',
    priceHint: 'from $899/person',
    image: p(346885),
  },
  {
    id: 'cruises',
    title: 'Cruises',
    description: 'Sail the Caribbean, Mediterranean, Alaska, and beyond.',
    priceHint: 'from $649/person',
    image: u('1544551763-46a013bb70d5'),
  },
];

export const HOTEL_PICKS = [
  {
    id: 1,
    city: 'Miami Beach',
    country: 'Florida, USA',
    price: 189,
    image: p(3251939),
  },
  {
    id: 2,
    city: 'New York',
    country: 'New York, USA',
    price: 249,
    image: u('1496442226666-8d4d0e62e6e9'),
  },
  {
    id: 3,
    city: 'Las Vegas',
    country: 'Nevada, USA',
    price: 129,
    image: p(250159),
  },
  {
    id: 4,
    city: 'Orlando',
    country: 'Florida, USA',
    price: 159,
    image: p(261102),
  },
];

/** Car hubs — iconic city the rental is based in */
export const TOP_LOCATIONS = [
  {
    id: 1,
    city: 'Miami',
    country: 'Florida, USA',
    price: 89,
    image: p(3251939),
  },
  {
    id: 2,
    city: 'Los Angeles',
    country: 'California, USA',
    price: 95,
    image: p(208745),
  },
  {
    id: 3,
    city: 'Las Vegas',
    country: 'Nevada, USA',
    price: 79,
    image: p(250159),
  },
  {
    id: 4,
    city: 'New York',
    country: 'New York, USA',
    price: 109,
    image: u('1514565131-fce0801e5785'),
  },
];

export const PACKAGE_DEALS = [
  {
    id: 1,
    destination: 'Cancún',
    details: '5 nights · All-inclusive resort',
    dates: 'Mar 12 – Mar 17',
    price: 1299,
    image: p(3601429),
  },
  {
    id: 2,
    destination: 'Paris',
    details: '7 nights · Hotel + tours',
    dates: 'Apr 5 – Apr 12',
    price: 1899,
    image: p(338515),
  },
  {
    id: 3,
    destination: 'Hawaii',
    details: '6 nights · Beach resort',
    dates: 'May 20 – May 26',
    price: 2149,
    image: u('1540959733332-eab4deabeeaf'),
  },
  {
    id: 4,
    destination: 'Rome',
    details: '5 nights · City center hotel',
    dates: 'Jun 3 – Jun 8',
    price: 1649,
    image: p(2033345),
  },
  {
    id: 5,
    destination: 'Bali',
    details: '8 nights · Villa + breakfast',
    dates: 'Jul 10 – Jul 18',
    price: 1999,
    image: p(1032650),
  },
  {
    id: 6,
    destination: 'Dubai',
    details: '4 nights · Luxury hotel',
    dates: 'Aug 1 – Aug 5',
    price: 1799,
    image: p(2044434),
  },
  {
    id: 7,
    destination: 'London',
    details: '6 nights · Flight + hotel',
    dates: 'Sep 14 – Sep 20',
    price: 2099,
    image: p(460672),
  },
  {
    id: 8,
    destination: 'Phuket',
    details: '7 nights · Beachfront resort',
    dates: 'Oct 5 – Oct 12',
    price: 1549,
    image: p(1450360),
  },
];

export const CRUISE_DEALS = [
  {
    id: 1,
    region: 'Caribbean',
    port: 'Miami',
    nights: 7,
    dates: 'Jun 8 – Jun 15',
    price: 849,
    image: p(996696),
  },
  {
    id: 2,
    region: 'Mediterranean',
    port: 'Barcelona',
    nights: 10,
    dates: 'Sep 2 – Sep 12',
    price: 1299,
    image: p(358457),
  },
  {
    id: 3,
    region: 'Alaska',
    port: 'Seattle',
    nights: 8,
    dates: 'Jul 14 – Jul 22',
    price: 1099,
    image: u('1470071459604-3b5ec3a7fe05'),
  },
  {
    id: 4,
    region: 'Northern Europe',
    port: 'Copenhagen',
    nights: 9,
    dates: 'Aug 20 – Aug 29',
    price: 1199,
    image: p(335964),
  },
];

export const FEATURES = [
  { title: '24/7 Concierge', text: 'Help with hotels, cars, packages, and cruises before and during your trip.' },
  { title: 'Best Rate Promise', text: 'Competitive pricing across travel suppliers with transparent fare rules.' },
  { title: 'Trusted Partners', text: 'Book through vetted hotel, rental, cruise, and package providers.' },
  { title: 'Flexible Options', text: 'Change dates, guests, rooms, and pickup details when plans shift.' },
];

export const EXCLUSIVE_DEALS = [
  {
    id: 1,
    category: 'Hotel',
    label: 'Miami Beach · Oceanview',
    dates: 'Apr 2 – Apr 6',
    price: 756,
    image: p(3251939),
  },
  {
    id: 2,
    category: 'Car',
    label: 'LAX · BMW 5 Series',
    dates: 'May 2 – May 7',
    price: 795,
    image: u('1555215695-3004980ad54e'),
  },
  {
    id: 3,
    category: 'Package',
    label: 'Cancún · 5-night all-inclusive',
    dates: 'Mar 12 – Mar 17',
    price: 1299,
    image: p(3601429),
  },
  {
    id: 4,
    category: 'Cruise',
    label: 'Caribbean · 7 nights from Miami',
    dates: 'Jun 8 – Jun 15',
    price: 849,
    image: p(1001682),
  },
];

export const REVIEWS = [
  { title: 'Hotel & car in one call', text: 'Booked a Miami hotel and rental through the same team — smooth from search to checkout.' },
  { title: 'Great package deal', text: 'Found a Cancún package with clear pricing and quick confirmation. Concierge was excellent.' },
  { title: 'Cruise made easy', text: 'Help choosing a Caribbean sailing and cabin type. Support answered every question 24/7.' },
];

export const HERO_IMAGE = p(1365425).replace('w=800', 'w=1600');
